import { useState } from "react";
import LoadingSpinner from "../../../Layout/components/LoadingSpinner";
import { Button, Grid, InputLabel, OutlinedInput, Stack } from "@mui/material";
import AnimateButton from "../../../Layout/components/@extended/AnimateButton";
import axios from "axios";

const EditBankingInfo = (props) => {
  console.log(props.user);
  const vendorDetails = props.user.bankInfo;
  const infoIV = props.user.vendorDetails.bank_info_iv;
  const [institutionCode, setInstitutionCode] = useState(
    vendorDetails.bank_institution_code
  );
  const [transitCode, setTransitCode] = useState(
    vendorDetails.bank_transit_code
  );
  const [accountNumber, setAccountNumber] = useState(
    vendorDetails.bank_account_number
  );

  const [submitting, setSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Handle file upload
  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      axios.post("/uploadCheque", formData).then((response) => {
        if (response.data.ok) {
          console.log(response.data.newImage);
          alert("File uploaded successfully!");
        } else {
          alert("Failed to upload file.");
        }
      });
    } catch (error) {
      console.error("Upload error:", error);
      alert("Error uploading file.");
    }
  };

  const onSubmit = async () => {
    setSubmitting(true);
    const submitData = {
      accountNumber: accountNumber,
      transitCode: transitCode,
      institutionCode: institutionCode,
      info_iv: infoIV,
    };
    // Prepare the file for upload if selected
    const formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile);
      await handleFileUpload(formData); // Upload the file before submitting form
    }

    axios
      .post("/updateBanking", submitData)
      .then((res) => {
        if (res.data.ok) {
          props.setEditBanking(false);
        }
      })
      .catch((err) => {
        console.error(err.message);
      })
      .finally(() => {
        setSubmitting(false);
        props.fetchVendorData();
      });
  };

  return (
    <LoadingSpinner isActive={submitting}>
      <Grid item xs={12} md={6}>
        <Stack spacing={1}>
          <InputLabel>Bank institution code</InputLabel>
          <OutlinedInput
            required
            name="institutionCode"
            id="institutionCode"
            type="text"
            value={institutionCode}
            onChange={(e) => setInstitutionCode(e.target.value)}
            placeholder="Institution Code"
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Stack spacing={1}>
          <InputLabel>Branch transit code</InputLabel>
          <OutlinedInput
            required
            name="transitCode"
            id="transitCode"
            type="text"
            value={transitCode}
            onChange={(e) => setTransitCode(e.target.value)}
            placeholder="Branch transit code"
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Stack spacing={1}>
          <InputLabel>Account number</InputLabel>
          <OutlinedInput
            required
            name="accountNumber"
            id="accountNumber"
            type="text"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            placeholder="Account number"
          />
        </Stack>
      </Grid>

      {/* File upload */}
      <Grid item xs={12} md={6}>
        <Stack spacing={1}>
          <InputLabel>Upload Void Cheque</InputLabel>
          <input
            type="file"
            accept="image/*,application/pdf"
            onChange={handleFileChange}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} marginTop={"2rem"}>
        <AnimateButton>
          <Stack direction={"row"} justifyContent={"right"} spacing={2}>
            <Button
              disableElevation
              size="sm"
              variant="outlined"
              color="secondary"
              onClick={() => props.setEditBanking(false)}
            >
              Cancel
            </Button>
            <Button
              disableElevation
              size="sm"
              variant="contained"
              color="primary"
              onClick={() => onSubmit()}
            >
              {props.vendorDetails.bankInfo.bank_account_number === null
                ? "Add"
                : "Update"}
            </Button>
          </Stack>
        </AnimateButton>
      </Grid>
    </LoadingSpinner>
  );
};

export default EditBankingInfo;
